module.exports = __webpack_public_path__ + "img/bg-and.b7a8c046.png";